<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--醫師簡介維護程式-->
    <v-flex xs12>
        <v-card class="cardBgColorStyle">

            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;margin-bottom: -5px">
                    {{this.menuInfo.funTitle}}
                </v-flex>

                <v-flex d-inline-flex pl-2>
                    <hismax-date-picker class="inputDate" :edit-type="startDate.editType" :date-type="startDate.dateType" :date-title="startDate.title" :edit-hint="startDate.hint" :edit-date="startDate.editDate" :clearable="startDate.clearable" @datePick="startDatePick"></hismax-date-picker>
                    <hismax-date-picker class="inputDate" :edit-type="endDate.editType" :date-type="endDate.dateType" :date-title="endDate.title" :edit-hint="endDate.hint" :edit-date="endDate.editDate" :clearable="endDate.clearable" @datePick="endDatePick"></hismax-date-picker>
                    <v-btn  middle class="pl-1 pr-1 ml-2 mt-3 regFRBtn" @click="axios_getMaintainLog(startDate.editDate,endDate.editDate)">查詢</v-btn>
                </v-flex>



                <!--<v-flex xs12 sm6 md4 d-inline-flex pl-2>-->
                <!--<v-switch color="white" class="mr-2"  style="float: right" hide-details  :label="`${effFlag==true?'有效資料':'全部資料'}`" v-model="effFlag"></v-switch>-->
                <!--</v-flex>-->




            </v-card>



            <v-flex style="padding-top:1rem">
                <v-data-table
                        dense
                        :search="search"
                        id="funListTable"
                        :loading="funListLoading"
                        :headers="funListHeaders"
                        :items="doctorList"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeFunListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <tr>
                            <td  class="px-1 text-left" >{{$UtilityJs.AD2ROC_DateTime(props.item.createDatetime,'showDT')}}</td>
                            <td  class="px-1 text-left" >{{props.item.userId}} </td>
                            <td  class="px-1 text-left" >{{ props.item.operType}}</td>
                            <td  class="px-1 text-left" >{{ props.item.operTarget}}</td>
                            <td  class="px-1 text-left" >{{props.item.logMemo}}</td>



                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">

                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>

                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="doctorList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-card>


        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import HismaxDatePicker from '../utility/HismaxDatePicker'
    export default {
        name: "MaintainLog",
        components: { HismaxDatePicker},
        data() {
            return {
                startDate:{
                    title:'開始日期',
                    hint:'',
                    editDate:'',
                    clearable:false,
                    dateType:'date',
                    editType:'menu'
                },
                endDate:{
                    title:'結束日期',
                    hint:'',
                    editDate:'',
                    clearable:false,
                    dateType:'date',
                    editType:'menu'
                },
                //程式功能清單
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                tableAlert:false,
                funListLoading:false,
                loadingText:'查詢中...',
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                doctorList: [],
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                funListHeaders:[
                    {
                        text: '建立日期時間',
                        // align: 'center',
                        value: 'createDatetime',
                        class:'px-1'
                    },
                    {
                        text: '登入者',
                        // align: 'left',
                        value: 'userId',
                        class:'px-1'
                    },
                    {
                        text: '操作類別',
                        // align: 'center',
                        value: 'operType',
                        class:'px-1'
                    },
                    {
                        text: '操作對象',
                        // align: 'center',
                        value: 'operTarget',
                        class:'px-1'
                    },
                    {
                        text: '備註',
                        // align: 'center',
                        value: 'logMemo',
                        class:'px-1'
                    },
                ]
            }
        },
        created(){
            let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
            this.endDate.editDate = today;
            let procDate = new Date();
            procDate.setDate(procDate.getDate()-7);
            this.startDate.editDate = this.$UtilityJs.AD2ROC_DateTime(new Date(procDate).toISOString(), 'date');
            this.axios_getMaintainLog(this.startDate.editDate,this.endDate.editDate)

        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },

            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  50}
                if(this.$vuetify.breakpoint.xl ==true){width =  40}
                return width
            },
        },
        watch:{
        },
        methods:{
            invalidDate(startDatetime,endDatetime){ //驗證起訖日期
                let result = '';
                let effSDate = startDatetime+" 00:00:00";
                let effEDate = endDatetime+" 00:00:00";
                if(startDatetime!==''&&endDatetime!==''){ //如果有輸入日期起訖範圍
                    if((Date.parse(effSDate)).valueOf() > (Date.parse(effEDate)).valueOf()){
                        result = '開始日期不能大於結束日期';
                    }else {
                        result = '';
                    }
                }else if((startDatetime==''&&endDatetime!=='')||(startDatetime!==''&&endDatetime=='')){ //如果只輸入起或迄日期
                    result = '請選擇開始和結束日期';
                }else if(startDatetime==null||endDatetime==null||startDatetime==''||endDatetime=='') {
                    result =  '請選擇開始和結束日期';
                }else {
                    result
                }
                return result;
            },
            startDatePick(item){
                this.startDate.editDate = item;
            },
            endDatePick(item){
                this.endDate.editDate = item;
            },
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓countDownId為null , countDownNo歸零
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },

            resizeFunListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                let height = userHeight-(270);
                let funListTable = document.getElementById('funListTable');
                funListTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getMaintainLog (sDate,eDate){ //查詢使用者紀錄
                let invalidDate = this.invalidDate(sDate,eDate);
                if(invalidDate==''){
                    this.countDown();//開始計時
                    this.funListLoading = true;
                    this.tableAlert = false;
                    this.doctorList = [];
                    let start = sDate.replace(new RegExp("-","gm"),"");
                    let end = eDate.replace(new RegExp("-","gm"),"");
                    let url = '';
                    url = this.$store.state.AppSetting.backSrvUrl + "maintainlog/datasearch/byrangedate/"+start+"/"+end;

                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            this.doctorList = response.data.resultSet;

                        }else{
                            this.tableAlert = true;
                            this.doctorList = [];
                        }
                        this.funListLoading = false;
                        this.stopCountDown();
                    }).catch(error =>  {
                        try {
                            console.log(error.response.data.status);
                            this.doctorList = [];
                        } catch(err) {
                            this.doctorList = [];
                        }
                        this.funListLoading = false;
                        this.stopCountDown();
                    });
                }else {
                    alert(invalidDate)
                    return;
                }

            },


        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>